import React, { useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { FiArrowRightCircle } from 'react-icons/fi'

import Button from '../../components/Button'
import Header from '../../components/Header'

import { Container, Content } from './styles'

const BemVindo: React.FC = () => {
  const history = useHistory()

  const handleStart = useCallback(async () => {
    history.push('/contribution')
  }, [history])

  return (
    <>
      <Header />
      <Container>
        <Content>
          <strong>Olá, você é empregado da Cibrius?</strong>
          <span>
            Então comece agora mesmo a planejar o seu futuro fazendo sua adesão
            ao Plano de Previdência Privada Cibrius.
          </span>
          <Button color="blue" onClick={handleStart} width="large">
            Simule aqui sua adesão!
            <FiArrowRightCircle size={45} />
          </Button>
        </Content>
      </Container>
    </>
  )
}

export default BemVindo
